import axios from '../../utils/axios2';

export default {

    namespaced: true,

    state: {
        jobcardMaintenance: null,
        jobcardMaintenances: null
    },

    mutations: {
        setJobcardMaintenance(state, payload) {
            state.jobcardMaintenance = payload;
        },
        setJobcardMaintenances(state, payload) {
            state.jobcardMaintenances = payload;
        }
    },

    actions: {
        storeJobcardMaintenance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `jobcard-maintenances`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        updateJobcardMaintenance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `jobcard-maintenances/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        fetchJobcardMaintenance({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-maintenances/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setJobcardMaintenance', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        },
        fetchJobcardMaintenances({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `jobcard-maintenances?jobcard_id=${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    commit('setJobcardMaintenances', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                })
            });
        },
        removeJobcardMaintenance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `jobcard-maintenances/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                })
            });
        }
    }

}